export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10829.67bfd2f0.jpg";